export default "__VITE_ASSET__U8KolIQt__"